export default (function() {
  let htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
  let htmlDom = document.getElementsByTagName('html')[0];
  htmlDom.style.fontSize = htmlWidth / 20 + 'px';
  // console.log(htmlDom.style.fontSize);
  // window.addEventListener('resize',()=>{
  //   htmlWidth = document.documentElement.clientWidth || document.body.clientWidth;
  //   htmlDom.style.fontSize = htmlWidth / 10 + 'px'
  // })
})()